module.exports = __webpack_public_path__ + "img/symbol_2.8db41e43.png";